module.exports = __webpack_public_path__ + "img/dupree-profile-min.883e0d31.jpg";